import React from 'react'
import { View, ViewStyle, StyleSheet } from 'react-native'
import { colors } from './theme'

type DividerWeight = 'regular' | 'strong'
type DividerColor = 'default' | 'subtle' | 'strong'

interface DividerProps {
	weight?: DividerWeight
	color?: DividerColor
	style?: ViewStyle
}

const weightMap: Record<DividerWeight, number> = {
	regular: 1,
	strong: 2,
}

const colorMap: Record<DividerColor, string> = {
	default: colors.gray300,
	subtle: colors.gray200,
	strong: colors.gray400,
}

export function Divider({ weight = 'regular', color = 'default', style }: DividerProps) {
	return (
		<View
			style={[
				styles.base,
				{
					height: weightMap[weight],
					backgroundColor: colorMap[color],
				},
				style,
			]}
		/>
	)
}

const styles = StyleSheet.create({
	base: {
		width: '100%',
	},
})
